module.exports = __webpack_public_path__ + "media/impactometre-utilisation-720.ac3de113.mp4";